// ============================================================================
// WHAT JOB IS THIS LINE — one answer, from the one list. Ben, 2026-09-16.
//
// ⛔ THIS FILE USED TO BE THE PROBLEM. It held two hand-written arrays of job
// names, written out because four places had each enumerated the spellings
// themselves and one of the four was missing a value, so five lines silently
// never produced a headline. Its own comment said a controlled list "is a
// decision Ben has open as of 2026-09-15". He made it: the list lives in the
// database, the picker reads it, and the column carries a validated reference
// to it. So the arrays are gone — a new job name is now a row in the catalogue,
// not an edit to this file.
//
// What remains is the one question every screen asks — "is this the building's
// main clean?" — answered in one place so it cannot be asked three different
// ways again. It was, in three spellings, which is how the word came to be
// stored three ways.
// ============================================================================

/** The catalogue code for the work almost every building buys: the main clean. */
export const MAIN_CLEAN_CODE = 'MAIN_CLEAN' as const;

/**
 * Is this line the building's main clean?
 *
 * ⛔ Ask this, never the string. The answer used to be spelled `Primary_Cleaner`,
 * `Primary Crew` and `Primary` in the data and tested with `ILIKE 'Primary%'`,
 * `= 'Primary_Cleaner'` and `~~* '%primary%'` in the code. One of those missed
 * five buildings and nobody noticed until a sub changeover priced a new line at
 * the whole building.
 */
export function isMainClean(serviceCode: string | null | undefined): boolean {
  return serviceCode === MAIN_CLEAN_CODE;
}

/**
 * The catalogue row a line carries, whichever shape the client hands back.
 *
 * ⚠️ The generated types describe a to-one embed as an ARRAY. Normalised here
 * once rather than asserted away in each caller, because asserting it away is
 * how a shape mismatch reaches a screen as `undefined` instead of a name.
 */
export function catalogLabel(
  embedded:
    | { display_name: string | null }[]
    | { display_name: string | null }
    | null
    | undefined,
): string | null {
  if (!embedded) return null;
  const one = Array.isArray(embedded) ? embedded[0] : embedded;
  return one?.display_name ?? null;
}
